import { render, staticRenderFns } from "./whitelist-form-modal.vue?vue&type=template&id=3d864d72&"
import script from "./whitelist-form-modal.vue?vue&type=script&lang=js&"
export * from "./whitelist-form-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports